import { Language } from '../../../../../../../types/language.enum'

export const DisclaimerLinks = {
  [Language.English]: 'https://www.lendcare.ca/en/consumers',
  [Language.French]: 'https://www.lendcare.ca/fr/consommateur',
}
